<form [formGroup]="form" (ngSubmit)="onSubmit()" class="card">
  <div class="card-body">
    <div class="mb-4">
      <h4 class="mb-2">{{ 'Settings::ScheduledCall:Title' | abpLocalization }}</h4>
      <p class="text-muted mb-0">{{ 'Settings::ScheduledCall:PageDescription' | abpLocalization }}</p>
    </div>

    <div class="row g-3 g-lg-4">
      <div class="col-12">
        <div class="d-flex align-items-center gap-2">
          <p-toggleswitch inputId="scheduledCallCallingWindowEnabled" formControlName="callingWindowEnabled" />
          <label class="form-label mb-0" for="scheduledCallCallingWindowEnabled">
            {{ 'Settings::ScheduledCall:CallingWindow' | abpLocalization }}
          </label>
        </div>
        <div class="text-muted small mt-1">{{ 'Settings::ScheduledCall:CallingWindowDescription' | abpLocalization }}</div>
      </div>

      <div class="col-12 col-lg-6">
        <label class="form-label indicates-required-field" for="scheduledCallCallingWindowStart">
          {{ 'Settings::ScheduledCall:CallingWindowStart' | abpLocalization }}
        </label>
        <p-datepicker
          inputId="scheduledCallCallingWindowStart"
          formControlName="callingWindowStart"
          [timeOnly]="true"
          hourFormat="24"
          [showIcon]="true"
          iconDisplay="input"
          [fluid]="true"
          appendTo="body" />
        @if (isControlInvalid('callingWindowStart')) {
          <div class="invalid-feedback d-block">
            {{ 'Settings::ScheduledCall:CallingWindowStart' | abpLocalization }} {{ '::Required' | abpLocalization }}
          </div>
        }
      </div>

      <div class="col-12 col-lg-6">
        <label class="form-label indicates-required-field" for="scheduledCallCallingWindowEnd">
          {{ 'Settings::ScheduledCall:CallingWindowEnd' | abpLocalization }}
        </label>
        <p-datepicker
          inputId="scheduledCallCallingWindowEnd"
          formControlName="callingWindowEnd"
          [timeOnly]="true"
          hourFormat="24"
          [showIcon]="true"
          iconDisplay="input"
          [fluid]="true"
          appendTo="body" />
        @if (isControlInvalid('callingWindowEnd')) {
          <div class="invalid-feedback d-block">
            {{ 'Settings::ScheduledCall:CallingWindowEnd' | abpLocalization }} {{ '::Required' | abpLocalization }}
          </div>
        }
      </div>

      @if (form.hasError('sameCallingWindowTimes')) {
        <div class="col-12 mt-1">
          <div class="invalid-feedback d-block">{{ 'Settings::ScheduledCall:CallingWindowSameTimes' | abpLocalization }}</div>
        </div>
      }

      <div class="col-12 col-lg-6">
        <label class="form-label indicates-required-field" for="scheduledCallMaxAssignmentAttempts">
          {{ 'Settings::ScheduledCall:MaxAssignmentAttempts' | abpLocalization }}
        </label>
        <p-inputNumber
          inputId="scheduledCallMaxAssignmentAttempts"
          formControlName="maxAssignmentAttempts"
          [min]="limits.minMaxAssignmentAttempts"
          [max]="limits.maxMaxAssignmentAttempts"
          [useGrouping]="false"
          [fluid]="true" />
        @if (isControlInvalid('maxAssignmentAttempts')) {
          <div class="invalid-feedback d-block">{{ 'Settings::ScheduledCall:MaxAssignmentAttemptsRange' | abpLocalization }}</div>
        } @else {
          <div class="text-muted small mt-1">{{ 'Settings::ScheduledCall:MaxAssignmentAttemptsHint' | abpLocalization }}</div>
        }
      </div>

      <div class="col-12 col-lg-6">
        <label class="form-label indicates-required-field" for="scheduledCallReassignmentCooldown">
          {{ 'Settings::ScheduledCall:ReassignmentCooldown' | abpLocalization }}
        </label>
        <p-inputNumber
          inputId="scheduledCallReassignmentCooldown"
          formControlName="reassignmentCooldownMinutes"
          [min]="limits.minReassignmentCooldownMinutes"
          [max]="limits.maxReassignmentCooldownMinutes"
          [useGrouping]="false"
          [fluid]="true" />
        @if (isControlInvalid('reassignmentCooldownMinutes')) {
          <div class="invalid-feedback d-block">{{ 'Settings::ScheduledCall:ReassignmentCooldownRange' | abpLocalization }}</div>
        } @else {
          <div class="text-muted small mt-1">{{ 'Settings::ScheduledCall:ReassignmentCooldownHint' | abpLocalization }}</div>
        }
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end px-4 pb-4">
    <cx-form-actions
      layout="inline"
      cancelVariant="outline-acx"
      [cancelLabel]="'::Cancel' | abpLocalization"
      [saveLabel]="isSubmitting ? ('::Saving' | abpLocalization) : ('::Save' | abpLocalization)"
      [disabled]="isLoading || form.invalid"
      [isSubmitting]="isSubmitting"
      (cancel)="onCancel()" />
  </div>
</form>
